/* eslint-disable camelcase */
import validator from "validator";

const Validations = {
	NotEmpty: (value) => !validator.isEmpty(value, { ignore_whitespace: true }),
	URL: (value) => Boolean(value) && validator.isURL(value, { require_tld: false }),
	UUID: (value) => Boolean(value) && validator.isUUID(value),
	Boolean: (value) => Boolean(value) && validator.isBoolean(value, { loose: true }),
	Float: (value) => Boolean(value) && validator.isFloat(value),
	Integer: (value) => Boolean(value) && validator.isInt(value)
};

const Parsers = {
	String: (value) => String(value),
	Boolean: (value) => String(value).toLocaleLowerCase() === "true",
	Float: (value) => parseFloat(value),
	Integer: (value) => parseInt(value, 10)
};

const getFromEnvironment = (key, validators, parser = Parsers.String, fallback = undefined) => {
	// Configuration not used on storybook
	if (process.env.STORYBOOK) {
		return "-";
	}

	const value = process.env[key];
	let isValid = true;

	if (validators) {
		validators.forEach(validate => {
			if (!validate(value)) {
				isValid = false;
			}
		});
	}

	if (!isValid) {
		if (fallback === undefined) {
			throw new Error(`Configuration parameter ${key} didn't pass the validation. And no fallback was provided`);
		} else {
			// eslint-disable-next-line no-console
			console.warn(`Configuration parameter ${key} didn't pass the validation. Using fallback value`);
			return fallback;
		}
	}

	return parser(value);
};

const config = {
	apiRoot: getFromEnvironment("REACT_APP_API_ROOT", [Validations.URL]),
	auth: {
		tenantId: getFromEnvironment("REACT_APP_AUTH_TENANT_ID", [Validations.NotEmpty]),
		appId: getFromEnvironment("REACT_APP_AUTH_APP_ID", [Validations.UUID]),
		apiId: getFromEnvironment("REACT_APP_AUTH_API_ID", [Validations.UUID])
	},
	feedbackUrl: getFromEnvironment("REACT_APP_FEEDBACK_URL", [Validations.URL]),
	helpUrl: getFromEnvironment("REACT_APP_HELP_URL", [Validations.URL]),
	appVersion: getFromEnvironment("REACT_APP_APP_VERSION", [Validations.NotEmpty]),
	showVersion: getFromEnvironment("REACT_APP_SHOW_VERSION", [Validations.Boolean], Parsers.Boolean, false),
	adobeAnalyticsEnabled:
		getFromEnvironment("REACT_APP_ADOBE_ANALYTICS_ENABLED", [Validations.Boolean], Parsers.Boolean, false),
	adobeEnvironment: getFromEnvironment("REACT_APP_ADOBE_ENVIRONMENT", [Validations.NotEmpty])
};

export default config;
